import axios from '@axios'

const PREFIX = 'portal-documentos'

export default {

  getPaginado(page, pageSize, filtros, filtroString, idFiltroCustom) {
    return axios.post(`${PREFIX}/paged?pagina=${page}&tamanhoPagina=${pageSize}&multiFiltro=${filtroString}&idFiltroCustom=${idFiltroCustom}`, filtros)
  },

  verificarNome(nome, id) {
    return axios.get(`${PREFIX}/verificar-nome/${id}?nome=${nome}`)
  },

  getFiltroCustomResumido() {
    return axios.get(`${PREFIX}/filtros-custom-resumido`)
  },

  getFiltroCustomById(id) {
    return axios.get(`${PREFIX}/filtros-custom/${id}`)
  },

  salvarFiltroCustom(filtro, docs) {
    return axios.post(`${PREFIX}/filtro?docs=${docs}`, filtro)
  },

  deleteFiltroCustom(filtroId) {
    return axios.delete(`${PREFIX}/filtro?filtroId=${filtroId}`)
  },

  getUsuariosFiltro() {
    return axios.get(`${PREFIX}/usuarios-filtro`)
  },

  baixaEmLote(nome, filtroDocs) {
    return axios.post(`${PREFIX}/baixa-lote?nomeArquivo=${nome}`, filtroDocs)
  },

  enviarEmLote(nome, filtroDocs) {
    return axios.post(`${PREFIX}/enviar-email?nomeArquivo=${nome}`, filtroDocs)
  },

  salvarEmail(empresaId, email) {
    return axios.post(`${PREFIX}/email?id=${empresaId}&email=${email}`)
  },

  getObservacoes(id) {
    return axios.get(`${PREFIX}/${id}/observacao`)
  },

  removerObservacao(id) {
    return axios.delete(`${PREFIX}/observacao/${id}/remover`)
  },

  salvarObservacao(observacao) {
    return axios.post(`${PREFIX}/observacao/salvar`, observacao)
  },

  getTodasLinhas(filtros, filtroString, filtroCustomId) {
    return axios.post(`${PREFIX}/allPaged?multiFiltro=${filtroString}&filtroCustomId=${filtroCustomId}`, filtros)
  },

  getTotalEmpresas() {
    return axios.get(`${PREFIX}/empresas`)
  },

  getTotalEmpresasFiltrado(body) {
    return axios.post(`${PREFIX}/empresas`, body)
  },
}
